import '@/server/utils/setupEnv';

import { Environment } from '@/internals/env.config';

import { DeviceType } from './resolveInviteCta';

export const makeSchemaTarget = (env: Environment, device: DeviceType, baseUrl?: string): string | undefined => {
  if (!baseUrl) return undefined;
  try {
    const url = new URL(baseUrl);

    if (device === DeviceType.WEB) {
      const newUrl = new URL(`${env.config.APP_ORIGIN}${url.pathname}${url.search}`);
      newUrl.searchParams.append('showAuth', 'true');
      return newUrl.toString();
    }

    return new URL(`${env.electron.scheme}://${url.hostname}${url.pathname}${url.search}`).toString();
  } catch (e) {
    return baseUrl;
  }
};
